<template>
    <div class="floor-3">
        <!-- 楼层标题 -->
        <div class="floor_title">
            <div class="floor_title_content">
                <span class="floor_title_border" :style="{ 'background-color': floorConfig.curr.title.value.color }"></span>
                <span class="floor_title_content_index" :style="{ color: floorConfig.curr.title.value.color }">{{
                    floorConfig.curr.title.value.text || "3F" }}</span>
                <!-- <img src="../../../assets/images/floor_title.png" alt /> -->
                <!-- <span class="floor_title_content_text">{{ floorConfig.curr.subTitle.value.text || "NiuShop" }}</span> -->
            </div>

            <!-- 右侧分类链接区 -->
            <div class="other-title" v-if="floorConfig.curr.categoryList.value.list" style="display: flex;">
                <div v-for="(item, index) in floorConfig.curr.categoryList.value.list" @click="opencat(item.category_id)"
                    style="margin-right: 10px;">
                    {{ item.category_name }}</div>
            </div>
        </div>
        <!-- 楼层内容区 -->
        <div>
            <div class="floor_content">
                <!-- 左侧区域 -->
                <div class="floor_content_left" style="display: block;">
                    <!-- 左侧左区1/3长图片区 -->
                    <div class="narrow">
                        <div @click="handleCargoClick(floorConfig.curr.leftImg.value.link.url)" class="narrow-sec-wrap">
                            <el-image v-if="floorConfig.curr.leftImg.value.url"
                                :src="$img(floorConfig.curr.leftImg.value.url)" fit="cover" />
                        </div>
                    </div>
                </div>
                <!-- 右侧区域 -->
                <div class="floor_content_right">
                    <cargo-item :cargo="item" v-for="(item, index) in rightlist" :key="index" />
                    <div style="width:19.3%;" v-for="item in 5 - rightlist.length % 5"></div>
                </div>

            </div>
            <!-- 底部区域 -->
            <div class="narrow" style="margin-top: 20px;width: 100%;height:250px;">
                <div class="floor_content_right " style="height:90px;margin-bottom: 10px;width: 100%;">
                    <CargoItemtwo :cargo="item" v-for="(item, index) in skuList" :key="index"
                        style="width:13.5%;height:71%;display: flex;" />
                    <div style="width:13.5%;" v-for="item in 6 - skuList.length % 6"></div>
                </div>
                <div style="display: flex;justify-content: space-around;">
                    <div style="height:125px;width: 12%;" @click="openpinpai(item.brand_id)"
                        v-for="(item, index) in floorConfig.curr.brandList.value.list" :key="index">
                        <el-image :src="$img(item.image_url)" fit="cover" style="width: 100%;height: 100%;" />
                    </div>
                    <div style="width:12%;" v-for="item in 8 - floorConfig.curr.brandList.value.list.length % 8"></div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import CargoNormal from "@/components/cargo/CargoNormal"
import { floorGoods, goodsSkuList } from "@/api/goods/goods"
import CargoItem from "./cargo_item_1"
import CargoItemtwo from "./cargo_item_2"

export default {
    name: "style1",
    components: {
        CargoNormal,
        CargoItem,
        CargoItemtwo
    },
    props: {
        config: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            floorConfig: {
                validated: false,
                rightCargos: []
            },
            skuList: [],
            rightlist: []
        }
    },
    created() {
        this.$store.dispatch("site/defaultFiles")
        this.getSkuList()
        this.getbottomlist()
    },
    computed: {
        ...mapGetters(["defaultGoodsImage"])
    },
    methods: {
        //分类
        opencat(id) {
            const locationaaa = 'list?category_id=' + id + '&level=1'
            window.open(locationaaa, "_blank")
        },
        openpinpai(id) {
            const locationaaa = 'list?brand_id=' + id
            window.open(locationaaa, "_blank")
        },
        handleCargoClick(skuId) {
            console.log(skuId)
            if (skuId) {
                this.$router.pushToTab(`/sku-${skuId}`)
            }
        },
        getbottomlist() {
            const sku_ids = this.floorConfig.curr.bottomGoodsList.value.sku_ids
            console.log(this.floorConfig.curr.bottomGoodsList.value)
            console.log(454545)
            console.log(sku_ids)
            goodsSkuList({ sku_ids })
                .then(res => {
                    console.log(2222222222)
                    console.log(res)
                    this.skuList = res.data
                })
                .catch(err => { })
        },
        getSkuList(categoryid) {
            const sku_ids = this.floorConfig.curr.rightGoodsList.value.sku_ids
            goodsSkuList({ sku_ids })
                .then(res => {
                    this.rightlist = res.data
                })
                .catch(err => { })
        }
    },
    watch: {
        config: {
            handler: function (curr) {
                if (curr && curr.title) {
                    this.floorConfig.curr = curr
                    this.floorConfig.validated = true
                    // this.floorConfig = { ...curr, validated: true }
                }
            },
            immediate: true,
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.floor-3 {
    margin-top: 25px;

    .floor_title {
        display: flex;
        justify-content: space-between;
    }

    .floor_title_content {
        display: flex;
        /* flex-direction: column; */
        align-items: center;
        margin-bottom: 10px;

        .floor_title_content_index {
            font-size: 24px;
            font-weight: 600;
        }

        .floor_title_content_text {
            color: rgba($color: #383838, $alpha: 0.2);
            font-size: 24px;
            text-transform: uppercase;
            letter-spacing: 5px;
            font-weight: 600;
        }
    }

    .other-title {
        text-align: right;
        margin-right: 15px;
        line-height: 53px;

        a {
            color: #838383;

            i {
                font-size: 14px;
            }

            &:hover {
                color: $base-color;
            }
        }
    }

    .floor-content {
        display: flex;
        flex-wrap: wrap;
    }
}

.floor {
    &_title_border {
        display: inline-block;
        width: 5px;
        height: 28px;
        background-color: #ff547b;
        margin-right: 12px;
        vertical-align: top;
    }

    &_content {
        display: flex;
        width: 100%;
        height: 500px;

        &_left {
            width: 19%;
            display: inline-flex;

            .narrow {
                width: 100%;
                position: relative;

                .el-image {
                    width: 100%;
                    height: 100%;
                    z-index: 100;
                }

                .narrow_link {
                    z-index: 110;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    // background-color: transparentize($ns-text-color-black, 0.7);
                    background-color: rgba(0, 0, 0, 0.1);
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    justify-content: space-around;
                    padding: 10px 0;

                    .el-link {
                        opacity: 1;
                        color: white;
                    }
                }
            }

            .wide {
                width: 65%;
                position: relative;

                .el-carousel {
                    z-index: 100;
                }

                .wide_link {
                    display: flex;
                    flex-direction: row;
                    position: absolute;
                    justify-content: center;
                    bottom: 10px;
                    left: 10px;
                    right: 10px;
                    // width: 100%;
                    flex-wrap: wrap;
                    z-index: 110;
                    // padding: 10px 0;
                    // background-color: transparentize($ns-text-color-black, 0.7);
                    opacity: 0.9;
                    cursor: pointer;

                    >div {
                        width: calc(25% - 2px);
                        height: 50px;
                        margin-left: 1px;
                        margin-right: 1px;
                        margin-bottom: 1px;
                        background: #ffffff;
                        opacity: 0.9;
                    }

                    .el-image {
                        width: 100%;
                        height: 100%;
                    }

                    .card {
                        width: 100%;
                        height: 100%;
                        border-radius: 0;
                        border: none;

                        // &:hover {
                        //     box-shadow: 0 2px 4px transparentize($color: $base-color-info, $amount: 0.3), 0 0 6px transparentize($color: $base-color-info, $amount: 0.4);
                        // }
                    }
                }
            }

            .narrow-sec-wrap,
            .wide-four-wrap {
                height: 100%;
                width: 100%;

                .el-image {
                    height: 100%;
                    width: 100%;
                    cursor: pointer;
                }
            }
        }

        &_right {
            width: 81%;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-around;
            align-content: space-between;
            cursor: pointer;
        }
    }
}

.floor-left-item {
    width: 19.3%;
}
</style>